<template>
    <div class="setting">
        <div class="row"><span class="label">模型ID</span> <div class="mid">{{modelInfo.mid}}</div></div>
        <div class="row"><span class="label">模型名称</span> <div><input type="text" v-model.lazy="modelInfo.name" /></div></div>
        <div class="row">
            <span class="label">尺寸</span> 
            <div class="inputs">
                <span><i>x</i> <input @change="changeSize('x')" v-model.lazy="modelInfo.size.x" type="number" /> <i>m</i></span>
                <span><i>y</i> <input @change="changeSize('y')" v-model.lazy="modelInfo.size.y" type="number" /> <i>m</i></span>
                <span><i>z</i> <input @change="changeSize('z')" v-model.lazy="modelInfo.size.z" type="number" /> <i>m</i></span>
            </div>
        </div>
        <div class="lock"><el-checkbox v-model="modelInfo.lock">保持尺寸比</el-checkbox></div>
        <div class="row"><span class="label">悬空</span> <div> <input v-model.lazy="modelInfo.height" type="number" /> </div> <i>m</i> </div>
        <div class="row">
            <span class="label">旋转</span> 
            <div class="inputs">
                <span><i>x</i> <input v-model.lazy="modelInfo.rotation.x" type="number" /> <i>rad</i></span>
                <span><i>y</i> <input v-model.lazy="modelInfo.rotation.y" type="number" /> <i>rad</i></span>
                <span><i>z</i> <input v-model.lazy="modelInfo.rotation.z" type="number" /> <i>rad</i></span>
            </div>
        </div>
        <div class="row">
            <span class="label">经纬度</span>
            <div class="inputs latlng">
                <input v-model.lazy="modelInfo.longitude" type="number" />
                <input v-model.lazy="modelInfo.latitude" type="number" />
            </div>
        </div>
    </div>
</template>

<script>
import BusEvent from '@/busEvent'

let v3 = new AMRT.Vector3()

export default {
    
    data(){
        return {
            modelInfo: {
                mid: '',
                name: '',
                size: { x: 0, y: 0, z: 0 },
                lock: true,
                height: 0,
                rotation: { x: 0, y: 0, z: 0 },
                originSize: { x: 0, y: 0, z: 0 },
                longitude: 0,
                latitude: 0
            }
        }
    },

    watch: {
        'modelInfo.lock': function( val ){
            if( val ) this.changeSize( 'x' )
        },

        modelInfo: {
            handler: function(){
                this.setModelInfo()
            },
            deep: true
        }
    },

    computed:{
        viewer: function(){
            return window.viewer
        }
    },

    mounted(){
        this.$bus.$on( BusEvent.SelectedChange, () => {
            this.init()
        })
        this.$bus.$on( BusEvent.MapLoaded, () => {
            this.viewer.transform._controls.addEventListener('dragging-changed', event => {
                if( event.value === false ){
                    this.init()
                }
            })
            this.viewer.addEventListener(AMRT.Event.DRAG_END, () => {
                this.init()
            })
        })
    },

    methods: {

        /**
         * 显示/隐藏模型设置
         */
        init(){
            if( this.viewer.selectedObject.length !== 1 ){
                Object.assign( this.modelInfo, this.$options.data().modelInfo )
                return
            }
            let selectedObject = this.viewer.selectedObject[0]
            let size = new AMRT.Vector3()
            new AMRT.Box3().setFromObject( selectedObject ).getSize( size )
            selectedObject.getWorldScale( v3 )
            let originSize = { 
                x: size.x / v3.x, 
                y: size.y / v3.y, 
                z: size.z / v3.z 
            }
            selectedObject.getWorldPosition( v3 )
            let cartographic = this.viewer.vector3ToLangLat( v3 )
            this.modelInfo.name = selectedObject.modelName || selectedObject.groupName
            this.modelInfo.size = this.$util.parseIntVector3( size )
            this.modelInfo.mid = selectedObject.mid
            this.modelInfo.rotation = this.$util.parseIntVector3( selectedObject.rotation )
            this.modelInfo.originSize = originSize
            this.modelInfo.height = Number( Number( cartographic.height ).toFixed(2) )
            this.modelInfo.latitude = cartographic.latitude
            this.modelInfo.longitude = cartographic.longitude
            this.modelInfo.visiable = true
        },

        /**
         * 设置模型参数
         */
        setModelInfo(){
            if( this.viewer.selectedObject.length !== 1 ) return
            if( this.modelInfo.name.trim() === '' ) return this.$message.warning('模型名称不能为空')
            if( this.modelInfo.size.x === '' || this.modelInfo.size.y === '' || this.modelInfo.size.z === '' || this.modelInfo.size.x <= 0 || this.modelInfo.size.y <= 0 || this.modelInfo.size.z <= 0 ) return this.$message.warning('尺寸不能为空，且不能小于或等于0')
            if( this.modelInfo.rotation.x === '' || this.modelInfo.rotation.y === '' || this.modelInfo.rotation.z === ''  ) return this.$message.warning('旋转角度不能为空')
            if( this.modelInfo.height === '' ) return this.$message.warning('高度不能为空')
            if( this.modelInfo.longitude === '' || this.modelInfo.longitude < -180 || this.modelInfo.longitude > 180 || 
                this.modelInfo.latitude === '' || this.modelInfo.latitude < -90 || this.modelInfo.latitude > 90  ){
                    return this.$message.warning('经纬度不正确')
            }
            var m = this.viewer.selectedObject[0]
            if( m.isGroup ){
                m.groupName = this.modelInfo.name
            }else{
                m.modelName = this.modelInfo.name
                m.mid = this.modelInfo.mid || ''
            }
            let originSize = this.modelInfo.originSize, 
            size = this.modelInfo.size, 
            rotation = this.modelInfo.rotation,
            position = this.viewer.langLatToVector3( this.modelInfo.longitude, this.modelInfo.latitude, this.modelInfo.height )
            position = m.parent.worldToLocal( position )
            m.position.copy( position )
            m.scale.set( size.x / originSize.x, size.y / originSize.y, size.z / originSize.z ) 
            m.rotation.set( Number( rotation.x ), Number( rotation.y ), Number( rotation.z ) )
            if( m.isLargeScene ){
                m.loader.updateLevels()
            }
            this.$bus.$emit( BusEvent.SceneChange )
        },

        /**
         * 重置模型信息面板
         */
        hideMenu(){
            this.$emit('hide')
        },

        /**
         * 同步修改尺寸
         */
        changeSize( axis ){
            if( !this.modelInfo.lock ) return
            var originSize = this.modelInfo.originSize
            var size = {}
            switch ( axis ) {
                case 'x':
                    size.x = this.modelInfo.size.x
                    size.y = Number( Number(this.modelInfo.size.x * ( originSize.y / originSize.x )).toFixed(3) )
                    size.z = Number( Number(this.modelInfo.size.x * ( originSize.z / originSize.x )).toFixed(3) )
                    break
                case 'y':
                    size.x = Number( Number(this.modelInfo.size.y * ( originSize.x / originSize.y )).toFixed(3) )
                    size.y = this.modelInfo.size.y
                    size.z = Number( Number(this.modelInfo.size.y * ( originSize.z / originSize.y )).toFixed(3) )
                    break
                case 'z': 
                    size.x = Number( Number(this.modelInfo.size.z * ( originSize.x / originSize.z )).toFixed(3) )
                    size.y = Number( Number(this.modelInfo.size.z * ( originSize.y / originSize.z )).toFixed(3) )
                    size.z = this.modelInfo.size.z
                    break
                default:
                    break
            }
            this.modelInfo.size = size
        },


    }
}
</script>

<style lang="scss" scoped>
.setting{
    width: 100%; height: 100%; position: relative;
    .head{ 
        width: calc(100% - 40px); height: 34px; display: flex; justify-content: space-between; padding: 10px 20px; align-items: center; border-radius: 5px; font-size: 14px; color: #182C49;
        .iconfont{cursor: pointer; font-size: 14px; &:hover{transform: scale(1.2); transition: 1s transform;}}
    }
    .label{ display: block; width: 65px; text-align: right; flex-shrink: 0; font-size: 14px; color: #182C49; margin-right: 10px; height: 100%; line-height: 50px; color: #999; }
    .lock{ 
        padding-left: 80px; margin-bottom: 10px; 
        /deep/ .is-checked .el-checkbox__inner{
            background-color: #1458EA;
            border-color: #1458EA;
        }
        /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{ color: #182C49; }
    }
    .row{
        &:nth-child(2),&:nth-child(5){
            input{margin-left: 5px;}
        }
        height: 50px; display: flex; align-items: center;
        .mid {padding: 0 10px; }
        div{ font-size: 14px; color: #182C49; }
        i{ color: #aaa; font-size: 12px; font-style: normal; }
        .inputs{
            height: 100%; display: flex; align-items: center; width: 290px;
            span{ 
                display: block; position: relative; margin: 0 5px;
                input{ padding: 0 22px 0 20px; width: 48px; }
                i:nth-child(1) { position: absolute; left: 7px; top: 7px; }
                i:nth-child(3) { position: absolute; right: 7px; top: 7px;}
            }
        }
        .latlng{
            input{width: 50%; overflow: hidden; margin: 0 5px;}
        }
        input{ 
            background-color: #FFF; height: 34px; border-radius: 4px; padding: 0 10px; width: 100%; color: #182C49;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
            &[type="number"]{
                -moz-appearance: textfield;
            }
        }
    }
    .btn{
        display: flex; justify-content: center; margin-top: 10px; 
        /deep/ .el-button{ width: 135px; height: 34px; line-height: 0; background-color: #1458EA; }
    }
}
</style>